var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('AppBar'),_c('v-main',[_c('h1',{staticClass:"text-center display-1"},[_vm._v("Avalie-nos")]),_c('RateUs')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }